import React from "react";
import classes from "./NoDataFound.module.css";
const NoDataFound = ({ title = "No Data Found" }) => {
  return (
    <section className={classes.wrapper}>
      <div className={classes.content}>
        <h3 className={classes.title}>{title}</h3>
      </div>
    </section>
  );
};

export default NoDataFound;
